// Inline drawer/panel for viewing the underlying workflow JSON. Replaces the
// previous react-bootstrap modal so we don't render a popup over the
// InteractivityStudio modal (see CLAUDE.md: "No popup over a popup"). The panel
// slides in from the right edge of the WorkflowTab graph container and stays
// scoped to that area so the host modal remains the top-level overlay.
import React, { useState } from "react";
import "./ShowCodePanel.scss";

export default function ShowCodePanel({ show, onClose, workflow, sectionId }) {
  const [copied, setCopied] = useState(false);
  if (!show) return null;
  const json = JSON.stringify(workflow || { variables: [], triggers: [] }, null, 2);
  const onCopy = () => {
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(json).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    }
  };
  return (
    <aside className="show-code-panel" role="complementary" aria-label="Workflow JSON">
      <header className="show-code-panel__head">
        <div className="show-code-panel__title">
          <i className="material-icons">code</i>
          Workflow JSON
          <span className="show-code-panel__sub">section: {String(sectionId)}</span>
        </div>
        <button
          type="button"
          className="show-code-panel__close"
          onClick={onClose}
          aria-label="Close"
        >
          <i className="material-icons">close</i>
        </button>
      </header>
      <div className="show-code-panel__toolbar">
        <button type="button" className="show-code-panel__copy" onClick={onCopy}>
          <i className="material-icons">content_copy</i>
          {copied ? "Copied!" : "Copy to clipboard"}
        </button>
      </div>
      <pre className="show-code-panel__pre">
        <code>{json}</code>
      </pre>
    </aside>
  );
}
